import type { TimelineEntry } from "../../session-logic";
import type { RuntimeAdmissionState } from "./useRuntimeAdmission";
import {
  buildAdmissionLaunchProgress,
  settleAdmissionLaunchProgress,
} from "./admissionLaunchProgress";
import type { MessagesTimelineRow } from "./MessagesTimeline.rowTypes";

/** Places the current admission after its user message, or at the end while that message is pending. */
export function insertAdmissionLaunchRow(
  rows: MessagesTimelineRow[],
  timelineEntries: ReadonlyArray<TimelineEntry>,
  runtimeAdmission: RuntimeAdmissionState | null | undefined,
  latestTurnStartedAt: string | null | undefined,
): MessagesTimelineRow[] {
  if (!runtimeAdmission) return rows;
  const currentAgentMessages = timelineEntries.flatMap((entry) =>
    entry.kind === "message" &&
    (entry.message.role === "assistant" || entry.message.role === "reasoning")
      ? [entry.message]
      : [],
  );
  const firstAgentMessage = currentAgentMessages.find(
    (message) => Date.parse(message.createdAt) >= Date.parse(runtimeAdmission.startedAt),
  );
  const settledAt = [firstAgentMessage?.createdAt, latestTurnStartedAt]
    .filter(
      (value): value is string =>
        typeof value === "string" && Date.parse(value) >= Date.parse(runtimeAdmission.startedAt),
    )
    .toSorted((a, b) => Date.parse(a) - Date.parse(b))[0];
  const userRowIndex = rows.findIndex(
    (row) =>
      row.kind === "message" &&
      row.message.role === "user" &&
      Date.parse(row.message.createdAt) >= Date.parse(runtimeAdmission.startedAt),
  );
  const launchRow: MessagesTimelineRow = {
    kind: "worktree-setup",
    id: "worktree-setup:admission",
    createdAt: runtimeAdmission.startedAt,
    progress: settledAt
      ? settleAdmissionLaunchProgress(runtimeAdmission, settledAt)
      : buildAdmissionLaunchProgress(runtimeAdmission),
    onCancel: runtimeAdmission.onCancel,
  };
  if (userRowIndex < 0) return [...rows, launchRow];
  return [...rows.slice(0, userRowIndex + 1), launchRow, ...rows.slice(userRowIndex + 1)];
}
